import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import './Hero.scss'


const Hero = ({ homeContent }) => {

    const navigate = useNavigate();

    function importAll(r) {
        let images = {};
        r.keys().map((item) => {
            images[item.replace("./", "")] = r(item);
        });
        return images;
    }

    const logoFolderImages = importAll(
        require.context(
            `../../../../../../public/images/logo1`,
            false,
            /\.(png|jpe?g|svg)$/
        )
    );

    const logoImagesArray = Object.values(logoFolderImages);
    const clientLogos = logoImagesArray.slice(-6);

    return (
        <div className="mobile-app-page">
            <div className="container main-container">
                <nav className="breadcrumb-nav" aria-label="breadcrumb">
                    <ol className="breadcrumb-list container">
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/services">Services</Link></li>
                        <li className="active">{homeContent.breadcrumb}</li>
                    </ol>
                </nav>
                <div className="back-button-container">
                    <div className="container">
                        <button onClick={() => navigate('/services')} className="btn-back">&larr; Back</button>
                    </div>
                </div>
                <section className="hero-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 ">
                                <div className="hero-text">
                                    <h1>{homeContent.title}</h1>
                                    <p>{homeContent.description}</p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="hero-image">
                                    <img src={homeContent.image} alt="banner image" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="clients-section">
                    <div className="container">
                        <h2>Our Clients, Our Pride</h2>
                        <div className="client-logos">
                            {clientLogos.map((logo, index) => (
                                <div className="client-logo" key={index}>
                                    <img src={logo} alt={`Client ${index + 1}`} />
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="cta-section">
                    <div className="container">
                        <div className="cta-card">
                            <h2> {homeContent.d1 || "Turn Your Vision Into Reality With Us"}</h2>
                            <p> {homeContent.d2 || "Start your journey with a personalized project quote — it's quick and easy!"}</p>
                            <Link to="/contact" className="btn-cta"> {homeContent.b || "Let's Build Together"}</Link>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    )
}

export default Hero;
